














import Vue from 'vue';
import { GlobalHeader, GlobalFooter } from '@/components/global-components';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import store from '@/store';
import { LoadingService } from '@/services';

export default Vue.extend({
  name: 'PageWrapper',
  beforeRouteEnter(to, from, next) {
    const promise = [
      store.dispatch('getMemberCustomerServiceInformation'),
      getContentArea([
        'footer-information',
        'related-sites-link-list',
        'resources-link-list',
        'need-help-link-list',
        'global-learn-link',
        'need-help-link-list-fallback',
      ]),
    ];
    return LoadingService.watchPromises(promise)
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  mounted() {
    this.$nextTick(() => {
      EventBus.$emit('initialLoadDone');
    });
  },
  components: {
    GlobalHeader,
    GlobalFooter,
  },
});
